var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0935H10V16.0935H0V14.0935ZM0 7.09351H20V9.09351H0V7.09351ZM0 0.0935059H20V2.09351H0V0.0935059ZM16 14.0935V11.0935H18V14.0935H21V16.0935H18V19.0935H16V16.0935H13V14.0935H16Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvail);
export default __webpack_public_path__ + "static/media/avail.eac700fec9b1c5a20bdcfe108516cf5b.svg";
export { ForwardRef as ReactComponent };